<template>
  <Can action="store" subject="package">
    <div data-component-group="package-dialog" data-component="add-new">
      <dialog-add
        icon="layers"
        :title="$t('create_package')"
        is-fullscreen
        :is-on="true"
        :on-close="onCancel"
      >
        <template v-slot:content>
          <forms-package-add-new
            :package-item="{}"
            class="elevation-1"
            :is-loading="isAddingPackage"
            :on-cancel="onCancel"
            :on-submit="createPackage"
          />
        </template>
      </dialog-add>
    </div>
  </Can>
</template>

<script>
  export default {
    emits: ['saved'],
    data() {
      return {
        isAddingPackage: false,
      };
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'packages', query: this.$route.query });
      },
      createPackage(packageItem) {
        this.isAddingPackage = true;

        return this.$store
          .dispatch('packages/create', packageItem)
          .then((res) => {
            this.$emit('saved');
            this.$router.push({ name: 'packages', query: this.$route.query });
            return res;
          })
          .catch((err) => err)
          .finally(() => {
            this.isAddingPackage = false;
          });
      },
    },
  };
</script>
